import { Input } from "@chakra-ui/react";
import React, { type ChangeEventHandler, type FC } from "react";

interface IDateInputProps {
  value?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
}

const DateInput: FC<IDateInputProps> = ({ value, onChange }) => {
  return <Input type="date" value={value} onChange={onChange} />;
};

export default DateInput;
